import PATHS from 'utils/paths';

import MonitorViewComponent from './MonitorViewComponent';

const DashboardMonitor = () => <MonitorViewComponent pageTitle="Dashboard Monitor" initialPage={PATHS.DASHBOARD} />;

export default DashboardMonitor;
